module.exports = __webpack_public_path__ + "static/media/human.5d65c41f.png";